/* MY STORE · Comprar por WhatsApp
   - Página de producto: abre el chat con la prenda, el talle elegido, la cantidad, el precio, el SKU y el link.
   - Carrito (lateral y página /cart): botón debajo de "Finalizar compra" que manda el pedido completo:
     prendas, talles, cantidades, descuentos (por ejemplo LOOK10), subtotal, total, nota y link del pedido.
   - Cada pedido por WhatsApp sale con un número de pedido único (ej. WA-0311-K7P2). El mismo carrito da siempre el mismo
     número; si cambia el contenido, sale uno nuevo. El número también queda en el link del pedido y en el carrito
     (atributo "Pedido WhatsApp"), así si el cliente termina comprando en la web, el pedido de Shopify lo muestra.
   - En días de promo (snippets/ms-promo.liquid) no se muestra "Comprar por WhatsApp": la compra va por el checkout. */
(function () {
  'use strict';
  if (window.__msWa) return;
  window.__msWa = true;

  var cfg = {};
  try { cfg = JSON.parse(document.getElementById('ms-tienda-cfg').textContent); } catch (e) {}
  var NUM = String(cfg.wa || '595981506229').replace(/\D/g, '') || '595981506229';
  var ROOT = String(cfg.root || '/').replace(/\/?$/, '/');
  var PEDIDO_WA = cfg.waPedido !== false;
  var ICONO = '<svg viewBox="0 0 32 32" aria-hidden="true"><path fill="currentColor" d="M16.04 3C9 3 3.3 8.7 3.3 15.73c0 2.25.6 4.45 1.72 6.38L3.2 28.8l6.86-1.8a12.7 12.7 0 0 0 5.98 1.52h.01c7.03 0 12.74-5.7 12.74-12.74C28.79 8.7 23.07 3 16.04 3Zm0 23.37h-.01a10.6 10.6 0 0 1-5.4-1.48l-.39-.23-4.07 1.07 1.09-3.97-.25-.41a10.56 10.56 0 0 1-1.62-5.62c0-5.84 4.76-10.6 10.61-10.6a10.6 10.6 0 0 1 10.6 10.61c0 5.85-4.76 10.63-10.56 10.63Zm5.82-7.95c-.32-.16-1.89-.93-2.18-1.04-.29-.11-.5-.16-.72.16-.21.32-.82 1.04-1.01 1.25-.19.21-.37.24-.69.08-.32-.16-1.35-.5-2.57-1.59a9.6 9.6 0 0 1-1.78-2.21c-.19-.32-.02-.49.14-.65.14-.14.32-.37.48-.56.16-.19.21-.32.32-.53.11-.21.05-.4-.03-.56-.08-.16-.72-1.73-.98-2.37-.26-.62-.52-.54-.72-.55h-.61c-.21 0-.56.08-.85.4-.29.32-1.12 1.09-1.12 2.66 0 1.57 1.14 3.08 1.3 3.3.16.21 2.25 3.43 5.44 4.81.76.33 1.35.52 1.81.67.76.24 1.46.21 2 .13.61-.09 1.89-.77 2.15-1.52.27-.74.27-1.38.19-1.52-.08-.13-.29-.21-.61-.37Z"/></svg>';

  function dinero(cents) {
    var n = Math.round(Number(cents || 0) / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return String(cfg.fmt || 'Gs. {{amount}}').replace(/\{\{\s*[a-z_]+\s*\}\}/, n).replace(/<[^>]*>/g, '').trim();
  }
  function enlace(txt) { return 'https://wa.me/' + NUM + '?text=' + encodeURIComponent(txt); }
  function saludo() { return '¡Hola MY STORE!' + (cfg.nombre ? ' Soy ' + cfg.nombre + '.' : ''); }
  function unicos(a) { var o = []; a.forEach(function (x) { if (x && o.indexOf(x) < 0) o.push(x); }); return o; }
  function esDefault(v) { return /^default title$/i.test(String(v || '')); }
  var NOMBRES = { size: 'Talle', talla: 'Talle', talle: 'Talle', tamano: 'Talle', 'tamaño': 'Talle', color: 'Color', colour: 'Color', title: '' };
  function opcion(n) { var k = String(n || '').trim().toLowerCase(); return (k in NOMBRES ? NOMBRES[k] : n) || 'Opción'; }
  /* ---------- Número de pedido ---------- */
  var LETRAS = '23456789ABCDEFGHJKLMNPQRSTUVWXYZ', DIAS = 3 * 864e5, memo = {};
  function nuevoCodigo() {
    var d = new Date(), r = '', b = null;
    try { b = window.crypto.getRandomValues(new Uint8Array(4)); } catch (e) {}
    for (var i = 0; i < 4; i++) r += LETRAS.charAt((b ? b[i] : Math.floor(Math.random() * 256)) % LETRAS.length);
    return 'WA-' + ('0' + d.getDate()).slice(-2) + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + r;
  }
  function codigoPara(firma) {
    if (memo[firma]) return memo[firma];
    var mapa = {}, ahora = Date.now();
    try { mapa = JSON.parse(localStorage.getItem('ms_wa_ped') || '{}') || {}; } catch (e) {}
    var e = mapa[firma];
    var c = e && e.c && ahora - e.t < DIAS ? e.c : nuevoCodigo();
    mapa[firma] = { c: c, t: e && e.c === c ? e.t : ahora };
    var limpio = {};
    Object.keys(mapa).sort(function (a, b) { return mapa[b].t - mapa[a].t; }).slice(0, 15).forEach(function (k) { if (ahora - mapa[k].t < DIAS) limpio[k] = mapa[k]; });
    try { localStorage.setItem('ms_wa_ped', JSON.stringify(limpio)); } catch (e2) {}
    return (memo[firma] = c);
  }
  function lineaPedido(c) { return '*Pedido N° ' + c + '*'; }

  function abrir(url) { var w = window.open(url, '_blank'); if (w) { try { w.opener = null; } catch (e) {} } else { location.href = url; } }

  /* ---------- Página de producto ---------- */
  function mensajeProducto(btn) {
    var caja = btn.closest('.ms-wa-pdp');
    var datos = null;
    try { datos = JSON.parse(caja.querySelector('[data-wa-datos]').textContent); } catch (e) { return null; }
    if (!datos || !datos.v || !datos.v.length) return null;
    var seccion = btn.closest('.shopify-section') || document;
    var form = seccion.querySelector('form[data-type="add-to-cart-form"]') || document.querySelector('form[data-type="add-to-cart-form"]');
    var idEl = form && form.querySelector('[name="id"]');
    var id = idEl ? Number(idEl.value) : 0;
    if (!id) { var m = /[?&]variant=(\d+)/.exec(location.search); if (m) id = Number(m[1]); }
    var v = datos.v[0];
    for (var i = 0; i < datos.v.length; i++) if (datos.v[i].id === id) { v = datos.v[i]; break; }
    var qEl = form && form.querySelector('[name="quantity"]');
    var q = Math.max(1, parseInt(qEl && qEl.value, 10) || 1);

    var L = [saludo(), v.a ? 'Quiero comprar este producto:' : 'Me interesa este producto:'];
    if (v.a) L.push(lineaPedido(codigoPara('p:' + v.id + ':' + q)));
    L.push('', '*' + datos.t + '*');
    (v.o || []).forEach(function (valor, j) {
      if (esDefault(valor)) return;
      L.push(opcion(datos.o && datos.o[j]) + ': ' + valor);
    });
    L.push('Cantidad: ' + q);
    var precio = 'Precio: ' + dinero(v.p) + (q > 1 ? ' c/u' : '');
    if (v.c > v.p) precio += ' (antes ' + dinero(v.c) + ')';
    L.push(precio);
    if (q > 1) L.push('Total: ' + dinero(v.p * q));
    if (v.s) L.push('SKU: ' + v.s);
    L.push(datos.u + '?variant=' + v.id);
    if (!v.a) { L.push(''); L.push('En la web figura agotado. ¿Les queda en algún local?'); }
    return L.join('\n');
  }

  /* ---------- Carrito ---------- */
  var ultimo = null, cargando = null, firma = '', codigoCarrito = '';

  function mensajeCarrito(c) {
    if (!c || !c.items || !c.items.length) return saludo() + '\nQuiero hacer una consulta sobre un pedido.';
    codigoCarrito = codigoPara('c:' + c.items.map(function (it) { return it.variant_id + ':' + it.quantity; }).join(','));
    var L = [saludo(), 'Quiero hacer este pedido:', lineaPedido(codigoCarrito), ''];
    var descuentos = {}, orden = [], codigos = [];
    function sumar(titulo, monto, tipo) {
      titulo = titulo || 'Descuento';
      if (!(titulo in descuentos)) { descuentos[titulo] = 0; orden.push(titulo); }
      descuentos[titulo] += Number(monto || 0);
      if (tipo === 'discount_code') codigos.push(titulo);
    }
    c.items.forEach(function (it, i) {
      L.push((i + 1) + '. *' + (it.product_title || it.title) + '*');
      var det = (it.options_with_values || []).filter(function (o) { return !esDefault(o.value); }).map(function (o) { return opcion(o.name) + ': ' + o.value; });
      det.push('Cantidad: ' + it.quantity);
      L.push('   ' + det.join(' · '));
      if (it.sku) L.push('   SKU: ' + it.sku);
      var allocs = it.line_level_discount_allocations || [];
      var orig = it.original_line_price, fin = it.final_line_price;
      var cu = it.quantity > 1 ? ' (' + dinero(it.original_price) + ' c/u)' : '';
      if (fin < orig) {
        var nombres = unicos(allocs.map(function (a) { return a.discount_application && a.discount_application.title; }));
        L.push('   ' + dinero(orig) + cu + ' → ' + dinero(fin) + (nombres.length ? ' con ' + nombres.join(', ') : ''));
      } else {
        L.push('   ' + dinero(fin) + cu);
      }
      allocs.forEach(function (a) { var d = a.discount_application || {}; sumar(d.title, a.amount, d.type); });
    });
    (c.cart_level_discount_applications || []).forEach(function (d) { sumar(d.title, d.total_allocated_amount, d.type); });

    L.push('');
    var totalDesc = orden.reduce(function (s, k) { return s + descuentos[k]; }, 0);
    if (totalDesc > 0) {
      L.push('Subtotal: ' + dinero(c.original_total_price));
      orden.forEach(function (k) { L.push('Descuento ' + k + ': −' + dinero(descuentos[k])); });
    }
    L.push('*Total: ' + dinero(c.total_price) + '* (' + c.item_count + (c.item_count === 1 ? ' prenda)' : ' prendas)'));
    if (totalDesc > 0) L.push('Ahorro: ' + dinero(totalDesc));
    if (cfg.envioGratis && c.total_price >= cfg.envioGratis * 100) L.push('Califica para envío gratis (compras desde ' + dinero(cfg.envioGratis * 100) + ')');
    if (c.note && String(c.note).trim()) { L.push(''); L.push('Nota: ' + String(c.note).trim()); }

    var link = location.origin + ROOT + 'cart/' + c.items.map(function (it) { return it.variant_id + ':' + it.quantity; }).join(',');
    codigos = unicos(codigos);
    var q = ['attributes%5BPedido%20WhatsApp%5D=' + encodeURIComponent(codigoCarrito)];
    if (codigos.length) q.unshift('discount=' + encodeURIComponent(codigos[0]));
    link += '?' + q.join('&');
    L.push('');
    L.push('Link del pedido: ' + link);
    return L.join('\n');
  }

  /* Deja el número en el carrito: si el cliente después compra en la web, el pedido de Shopify lo muestra en "Notas" */
  function marcarCarrito(c) {
    if (!codigoCarrito || !c || !c.items || !c.items.length) return;
    if (c.attributes && c.attributes['Pedido WhatsApp'] === codigoCarrito) return;
    try {
      fetch(ROOT + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: { 'Pedido WhatsApp': codigoCarrito } }), keepalive: true })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (n) { if (n && ultimo) ultimo.attributes = n.attributes; })
        .catch(function () {});
    } catch (e) {}
  }

  function pintarCarrito() {
    var url = enlace(mensajeCarrito(ultimo));
    document.querySelectorAll('[data-wa-carrito]').forEach(function (a) { a.href = url; });
  }
  function pedirCarrito() {
    var p = fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); })
      .then(function (c) { ultimo = c; return c; })
      .catch(function () { return ultimo; })
      .then(function (c) { if (cargando === p) cargando = null; pintarCarrito(); return c; });
    cargando = p;
    return p;
  }
  function firmaCarrito() {
    var f = [];
    document.querySelectorAll('[data-cart-subtotal], cart-icon, .cart-bubble__text-count').forEach(function (e) { f.push(e.getAttribute('value') || e.textContent.trim()); });
    return f.join('|');
  }
  function inyectarCarrito() {
    if (!PEDIDO_WA) return;
    var nuevos = false;
    document.querySelectorAll('.cart__ctas').forEach(function (ctas) {
      if (ctas.querySelector('[data-wa-carrito]')) return;
      var chk = ctas.querySelector('.cart__checkout-button');
      if (!chk) return;
      var a = document.createElement('a');
      a.className = 'ms-wa-btn ms-wa-btn--cart';
      a.target = '_blank';
      a.rel = 'noopener';
      a.setAttribute('data-wa-carrito', '');
      a.href = enlace(mensajeCarrito(ultimo));
      a.innerHTML = ICONO + '<span>Comprar por WhatsApp</span>';
      chk.insertAdjacentElement('afterend', a);
      nuevos = true;
    });
    var f = firmaCarrito();
    if (nuevos || f !== firma) { firma = f; if (document.querySelector('[data-wa-carrito]')) pedirCarrito(); }
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-wa-producto]');
    if (b) {
      var msg = mensajeProducto(b);
      if (msg) b.href = enlace(msg);
      return;
    }
    var c = e.target.closest('[data-wa-carrito]');
    if (c && cargando) {
      e.preventDefault();
      c.classList.add('is-loading');
      cargando.then(function (cart) { c.classList.remove('is-loading'); abrir(enlace(mensajeCarrito(cart))); marcarCarrito(cart); });
    } else if (c) {
      marcarCarrito(ultimo);
    }
  });
  document.addEventListener('cart:update', function () { if (document.querySelector('[data-wa-carrito]')) pedirCarrito(); });

  /* En producto: mientras el botón "Comprar por WhatsApp" se ve en pantalla, se esconde el botón flotante para que no lo tape */
  function vigilarFlotante() {
    var fijo = document.querySelector('.ms-wa');
    var pdp = document.querySelector('.ms-wa-pdp');
    if (!fijo || !pdp || pdp.__msObs || !('IntersectionObserver' in window)) return;
    pdp.__msObs = true;
    new IntersectionObserver(function (es) {
      fijo.classList.toggle('ms-wa--oculto', es[0].isIntersecting);
    }, { rootMargin: '0px 0px -40px 0px' }).observe(pdp);
  }
  function arrancar() { inyectarCarrito(); vigilarFlotante(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrancar); else arrancar();
  var pend = 0;
  new MutationObserver(function () {
    if (pend) return;
    pend = setTimeout(function () { pend = 0; inyectarCarrito(); }, 120);
  }).observe(document.documentElement, { childList: true, subtree: true });

  window.msWhatsApp = { mensajeCarrito: mensajeCarrito, mensajeProducto: mensajeProducto, pedirCarrito: pedirCarrito, activo: PEDIDO_WA };
})();
